module.exports = __webpack_public_path__ + "static/media/group_26@2x.45cf12fa.jpg";